// Hindi
const dict = {
  // Brand / common
  "Every Win, Securely Paid.": "हर जीत, सुरक्षित भुगतान।",
  "Loading Sara777": "Sara777 लोड हो रहा है",
  "App version {version}": "ऐप वर्ज़न {version}",
  "Language": "भाषा",
  "Home": "होम",
  "Account": "खाता",
  "Wallet": "वॉलेट",
  "History": "इतिहास",
  "All Bids": "सभी बोलियाँ",
  "Profile": "प्रोफ़ाइल",
  "My Profile": "मेरी प्रोफ़ाइल",
  "Open menu": "मेनू खोलें",
  "Close menu": "मेनू बंद करें",
  "Go back": "वापस जाएँ",
  "Back": "वापस",
  "Close": "बंद",
  "Open": "ओपन",
  "Submit": "सबमिट करें",
  "Cancel": "रद्द करें",
  "Continue": "आगे बढ़ें",
  "Update": "अपडेट करें",
  "Copy": "कॉपी करें",
  "Change": "बदलें",
  "Refresh": "रिफ्रेश करें",
  "Date": "तारीख",
  "Status": "स्थिति",
  "Action": "कार्रवाई",
  "Remark": "टिप्पणी",
  "Amount": "राशि",
  "Points": "पॉइंट्स",
  "Bids": "बोलियाँ",
  "Session": "सत्र",
  "Pending": "लंबित",
  "Failed": "विफल",
  "Success": "सफल",
  "optional": "वैकल्पिक",
  "Since {date}": "{date} से",

  // Sidebar
  "Account Statement": "खाता विवरण",
  "Game Rates": "गेम रेट्स",
  "Terms & Conditions": "नियम और शर्तें",
  "Video": "वीडियो",
  "Logout": "लॉग आउट",
  "Privacy Policy": "गोपनीयता नीति",

  // Login / sign-up / MPIN / OTP
  "Login": "लॉगिन",
  "Sign up": "साइन अप करें",
  "New here?": "नए हैं?",
  "Already have an account?": "पहले से खाता है?",
  "Have an account?": "खाता है?",
  "Enter Number": "नंबर दर्ज करें",
  "Enter your valid mobile number": "अपना सही मोबाइल नंबर दर्ज करें",
  "Mobile number": "मोबाइल नंबर",
  "Mobile Number": "मोबाइल नंबर",
  "Enter mobile number": "मोबाइल नंबर दर्ज करें",
  "4-digit MPIN": "4 अंकों का MPIN",
  "Enter your 4-digit MPIN": "अपना 4 अंकों का MPIN दर्ज करें",
  "Show MPIN": "MPIN दिखाएँ",
  "Hide MPIN": "MPIN छिपाएँ",
  "Create Account": "खाता बनाएँ",
  "Create your new account": "अपना नया खाता बनाएँ",
  "Full name": "पूरा नाम",
  "Email address (optional)": "ईमेल पता (वैकल्पिक)",
  "Create MPIN": "MPIN बनाएँ",
  "Set a 4-digit PIN to log in quickly": "जल्दी लॉगिन के लिए 4 अंकों का PIN सेट करें",
  "Enter MPIN": "MPIN दर्ज करें",
  "Confirm MPIN": "MPIN की पुष्टि करें",
  "{label} digit {n}": "{label} अंक {n}",
  "Never share your MPIN with anyone.": "अपना MPIN कभी किसी से साझा न करें।",
  "MPINs match": "MPIN मेल खाते हैं",
  "MPINs don't match. Try again.": "MPIN मेल नहीं खाते। फिर से कोशिश करें।",
  "Enter your MPIN to login": "लॉगिन के लिए अपना MPIN दर्ज करें",
  "Enter OTP": "OTP दर्ज करें",
  "Verify your mobile number": "अपना मोबाइल नंबर सत्यापित करें",
  "Verify": "सत्यापित करें",

  // Home
  "Add Money": "पैसे जोड़ें",
  "Withdraw": "निकासी",
  "Betting is Running Now": "बेटिंग अभी चालू है",
  "Betting is Closed for Today": "आज के लिए बेटिंग बंद है",
  "Play {name}": "{name} खेलें",
  "{name} chart": "{name} चार्ट",
  "Chart Info": "चार्ट जानकारी",
  "Contact Support": "सहायता से संपर्क करें",
  "Jodi Chart": "जोड़ी चार्ट",
  "Pana Chart": "पाना चार्ट",
  "Past jodi results": "पिछले जोड़ी परिणाम",
  "Past panna results": "पिछले पाना परिणाम",
  "Call Now": "अभी कॉल करें",
  "Talk to our support team": "हमारी सहायता टीम से बात करें",
  "WhatsApp": "व्हाट्सऐप",
  "Chat with us on WhatsApp": "व्हाट्सऐप पर हमसे चैट करें",

  // Game types
  "Select a game type to play": "खेलने के लिए गेम का प्रकार चुनें",
  "Single Digit": "सिंगल अंक",
  "Single Digit Bulk": "सिंगल अंक बल्क",
  "Jodi Digit": "जोड़ी अंक",
  "Jodi Digit Bulk": "जोड़ी अंक बल्क",
  "Single Pana": "सिंगल पाना",
  "Single Pana Bulk": "सिंगल पाना बल्क",
  "Double Pana": "डबल पाना",
  "Double Pana Bulk": "डबल पाना बल्क",
  "Triple Pana": "ट्रिपल पाना",
  "Triple Pana Bulk": "ट्रिपल पाना बल्क",
  "Half Sangam": "हाफ संगम",
  "Full Sangam": "फुल संगम",
  "Jodi": "जोड़ी",
  "Single Panna": "सिंगल पाना",
  "Double Panna": "डबल पाना",
  "Triple Panna": "ट्रिपल पाना",
  "Tripple Panna": "ट्रिपल पाना",

  // Playing
  "Enter points": "पॉइंट्स दर्ज करें",
  "Enter {label}": "{label} दर्ज करें",
  "Add Bid": "बोली जोड़ें",
  "Submit Bid": "बोली सबमिट करें",
  "Pana": "पाना",
  "Digits": "अंक",
  "Open Pana": "ओपन पाना",
  "Close Pana": "क्लोज़ पाना",
  "Open Digit": "ओपन अंक",
  "Close Digit": "क्लोज़ अंक",
  "No bids added yet": "अभी तक कोई बोली नहीं जोड़ी गई",
  "Remove bid {number}": "बोली {number} हटाएँ",
  "Bid status": "बोली की स्थिति",
  "Note: Bid once played will not be cancelled": "नोट: एक बार लगाई गई बोली रद्द नहीं होगी",
  "HOLD": "होल्ड",
  "LOADING...": "लोड हो रहा है...",
  "Failed !!": "विफल !!",

  // Bids / history
  "Transaction ID": "ट्रांज़ैक्शन ID",
  "Placed": "लगाई गई",
  "No bid history found.": "कोई बोली इतिहास नहीं मिला।",
  "Balance": "बैलेंस",
  "No transactions yet": "अभी तक कोई लेन-देन नहीं",
  "Deposit": "जमा",
  "No history found.": "कोई इतिहास नहीं मिला।",
  "In Process": "प्रक्रिया में",
  "Declined": "अस्वीकृत",
  "User Withdrawal / deposit History": "निकासी / जमा इतिहास",

  // Charts
  "Bottom": "नीचे",
  "Back to top": "ऊपर जाएँ",
  "Mon": "सोम",
  "Tue": "मंगल",
  "Wed": "बुध",
  "Thu": "गुरु",
  "Fri": "शुक्र",
  "Sat": "शनि",
  "Sun": "रवि",

  // Rates / how to play
  "Main game win ratio for all bids": "सभी बोलियों के लिए मुख्य गेम जीत अनुपात",
  "{min} KA {max}": "{min} का {max}",
  "How To Play": "कैसे खेलें",
  "Download our application from Google Play Store or from our official website.": "हमारा ऐप Google Play Store या हमारी आधिकारिक वेबसाइट से डाउनलोड करें।",
  "Register with your Mobile Number, Email ID, and User Name on our platform.": "हमारे प्लेटफ़ॉर्म पर अपने मोबाइल नंबर, ईमेल ID और यूज़र नेम से रजिस्टर करें।",
  "Login to the application using your Mobile Number and MPIN.": "अपने मोबाइल नंबर और MPIN से ऐप में लॉगिन करें।",
  "Select the Game type, choose your favourite number, and start to play the game.": "गेम का प्रकार चुनें, अपना पसंदीदा नंबर चुनें और खेलना शुरू करें।",
  "Get a chance to win up to 10 Lac Points.": "10 लाख पॉइंट्स तक जीतने का मौका पाएँ।",

  // Wallet
  "Add Fund": "फंड जोड़ें",
  "Instant deposit via UPI / QR Code": "UPI / QR कोड से तुरंत जमा",
  "Manual Deposit": "मैनुअल जमा",
  "Upload your payment screenshot": "अपने भुगतान का स्क्रीनशॉट अपलोड करें",
  "Withdraw Fund": "फंड निकालें",
  "Fast and secure withdrawal to bank": "बैंक में तेज़ और सुरक्षित निकासी",
  "Deposit & Withdraw History": "जमा और निकासी इतिहास",
  "Check your past transactions statement": "अपने पिछले लेन-देन का विवरण देखें",
  "Add Bank Details": "बैंक विवरण जोड़ें",
  "Update bank account for instant payouts": "तुरंत भुगतान के लिए बैंक खाता अपडेट करें",
  "Total Wallet Balance": "कुल वॉलेट बैलेंस",
  "Pay": "भुगतान करें",
  "Minimum deposit limit is {amount}.": "न्यूनतम जमा सीमा {amount} है।",
  "Enter withdraw points": "निकासी पॉइंट्स दर्ज करें",
  "Amount is sent to your saved bank account.": "राशि आपके सेव किए गए बैंक खाते में भेजी जाती है।",
  "Update bank details": "बैंक विवरण अपडेट करें",
  "Pay to the UPI ID below, then enter the UTR number and upload the payment screenshot.": "नीचे दी गई UPI ID पर भुगतान करें, फिर UTR नंबर दर्ज करें और भुगतान का स्क्रीनशॉट अपलोड करें।",
  "Enter amount": "राशि दर्ज करें",
  "Pay to UPI ID": "इस UPI ID पर भुगतान करें",
  "UTR Number": "UTR नंबर",
  "Enter 12-digit UTR number": "12 अंकों का UTR नंबर दर्ज करें",
  "Payment Screenshot": "भुगतान स्क्रीनशॉट",
  "Tap to upload screenshot": "स्क्रीनशॉट अपलोड करने के लिए टैप करें",
  "Tap to change": "बदलने के लिए टैप करें",
  "PNG or JPG": "PNG या JPG",
  "Bank Details": "बैंक विवरण",
  "IFSC Code": "IFSC कोड",
  "Account number": "खाता संख्या",
  "Bank name": "बैंक का नाम",
  "Account holder name": "खाताधारक का नाम",
  "Google Pay number": "Google Pay नंबर",
  "PhonePe number": "PhonePe नंबर",
  "Paytm number": "Paytm नंबर",

  // Profile
  "Edit profile": "प्रोफ़ाइल बदलें",
  "Joined since": "कब से जुड़े",
  "Phone": "फ़ोन",
  "Wallet Balance": "वॉलेट बैलेंस",
  "Update User Information": "यूज़र जानकारी अपडेट करें",
  "Name": "नाम",
  "Email": "ईमेल",
  "PhonePe": "PhonePe",
  "Google Pay": "Google Pay",
  "Paytm": "Paytm",
  "Name is required.": "नाम ज़रूरी है।",
  "Email is required.": "ईमेल ज़रूरी है।",
  "Email is invalid.": "ईमेल सही नहीं है।",
  "PhonePe number must be 10 digits.": "PhonePe नंबर 10 अंकों का होना चाहिए।",
  "Paytm number must be 10 digits.": "Paytm नंबर 10 अंकों का होना चाहिए।",
  "Google Pay number must be 10 digits.": "Google Pay नंबर 10 अंकों का होना चाहिए।",

  // Pop-up messages
  "Enter User name !!": "यूज़र नेम दर्ज करें !!",
  "Enter Valid mobile number !!": "सही मोबाइल नंबर दर्ज करें !!",
  "Enter Valid email address !!": "सही ईमेल पता दर्ज करें !!",
  "Enter your 4-digit MPIN !!": "अपना 4 अंकों का MPIN दर्ज करें !!",
  "Only 4 digit allow !!": "केवल 4 अंक मान्य हैं !!",
  "Mpin does not match with confirm Mpin.": "MPIN और पुष्टि MPIN मेल नहीं खाते।",
  "This number is already registered. Please login.": "यह नंबर पहले से रजिस्टर है। कृपया लॉगिन करें।",
  "This number is not registered. Please create your account.": "यह नंबर रजिस्टर नहीं है। कृपया अपना खाता बनाएँ।",
  "Unable to sign in. Please try again.": "लॉगिन नहीं हो सका। कृपया फिर से कोशिश करें।",
  "Unable to continue. Please try again.": "आगे नहीं बढ़ सके। कृपया फिर से कोशिश करें।",
  "Unable to create account. Please try again.": "खाता नहीं बन सका। कृपया फिर से कोशिश करें।",
  "Api Error": "सर्वर त्रुटि",
  "Something went wrong. Please try again.": "कुछ गलत हो गया। कृपया फिर से कोशिश करें।",
  "This Market Betting Is Closed For Today.": "इस मार्केट में आज के लिए बेटिंग बंद है।",
  "Please Enter minimum 10 Points.": "कृपया कम से कम 10 पॉइंट्स दर्ज करें।",
  "Please Enter Points for Betting.": "कृपया बेटिंग के लिए पॉइंट्स दर्ज करें।",
  "Please Select Bids for Betting.": "कृपया बेटिंग के लिए बोलियाँ चुनें।",
  "Please enter a valid Number.": "कृपया सही नंबर दर्ज करें।",
  "Please Enter Amount first.": "कृपया पहले राशि दर्ज करें।",
  "Please Enter UTR first.": "कृपया पहले UTR दर्ज करें।",
  "Please select a valid image file.": "कृपया सही इमेज फ़ाइल चुनें।",
  "UPI copied to clipboard!": "UPI क्लिपबोर्ड पर कॉपी हो गया!",
  "Profile Updated Successfully.": "प्रोफ़ाइल सफलतापूर्वक अपडेट हो गई।",
};

export default dict;
